import React, { useState } from 'react';
import { ImageHeader, Container, DivTextAlignCenter, SubmitButton, BackButton, BackDiv, DivLogo, Title } from '../../styles/styles'
import Logo from '../../assets/seclogoanimado.gif'
import PoweredBy from '../../assets/powered by@2x.png'
import DicaCVV from '../../assets/dicacvv.png'
import Card from 'react-credit-cards';
import '../../styles/credit-card.css';
import { formatCreditCardNumber, formatExpirationDate, formatCVC, formatCardName } from '../../scripts/utils';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Swipeable from 'react-swipeable';
import { cpfMask } from '../../scripts/mask';
import { cpf } from 'cpf-cnpj-validator';
import Payment from 'payment';
import { useAlert } from 'react-alert';
import TransactionServicePayGo from '../../services/TransactionServicePayGo';
import { statusEnum } from '../../types/EnumStatus';
import { generateCardHash } from '../../scripts/paygo';
import { Modal, Placeholder } from 'react-bootstrap';
import { IAvulso, ICobranca } from '../../types/TicketInterface';
import GifCarregando from '../../assets/gif carregando.gif';
import GifCerto from '../../assets/gif certo.gif';
import GifErro from '../../assets/gif erro.gif';
import TicketService from '../../services/TicketService';
import { Icon, IconProp } from '@fortawesome/fontawesome-svg-core';
import moment from 'moment';
import { autorizadorEnum } from '../../types/EnumAutorizador';
import CryptoJS from 'crypto-js';
import TransactionServiceSiTef from '../../services/TransactionServiceSiTef';
import PaymentServiceSiTef from '../../services/PaymentServiceSiTef';

class PayCard extends React.Component {

    state = {
        number: '',
        name: '',
        expiry: '',
        cvc: '',
        issuer: '',
        cpf: '',
        cpfIsValid: false,
        focused: undefined,
        formData: null,
        swipe: false,
        card: null,
        isOpen: false,
        gif: GifCarregando
    };
    form: any;

    ticket = JSON.parse(localStorage.getItem('ticket')!) as IAvulso;
    cobranca = JSON.parse(localStorage.getItem('cobranca')!) as ICobranca;

    handleCallback = ({ issuer }: any, isValid: any) => {
        if (isValid) {
            this.setState({ issuer });
        }
    };

    handleInputFocus = ({ target }: any) => {
        this.setState({
            focused: target.id
        });
    };

    handleInputChange = ({ target }: any) => {
        if (target.id === 'number') {
            target.value = formatCreditCardNumber(target.value);

            this.setState({ 'issuer': Payment.fns.cardType(target.value) });
        }
        else if (target.id === 'expiry') {
            target.value = formatExpirationDate(target.value);
        }
        else if (target.id === 'cvc') {
            target.value = formatCVC(target.value);
        }
        else if (target.id === 'name') {
            target.value = formatCardName(target.value);
        }
        else if (target.id === 'cpf') {
            target.value = cpfMask(target.value);

            if (!cpf.isValid(target.value)) {
                document.getElementById('cpf')!.style.border = '2px solid #dee2e6';
                document.getElementById('cpf')!.className = 'form-control border-danger';
            }
            else {
                document.getElementById('cpf')!.style.border = '2px solid #dee2e6';
                document.getElementById('cpf')!.className = 'form-control border border-success';
            }

            this.setState({ 'cpfIsValid': cpf.isValid(target.value) });
        }

        this.setState({ [target.id]: target.value });
    };

    handleSubmit = async (e: any) => {
        if (document.getElementById('cpf')!.className == 'form-control border-danger') {
            useAlert().error('CPF inválido!');
        }

        e.preventDefault();

        localStorage.setItem('bandeira', 'CREDITO');
        var strDocumento = (this.state.cpf).replaceAll('.', '').replace('-','').replace('/','');
        localStorage.setItem('CPF/CNPJ', strDocumento);

        if (this.cobranca.opcaoIntegracao == 0) {

            let cardInfo = {
                number: this.state.number.replace(/ /g, ''),
                expirationMonth: this.state.expiry.substring(0, 2),
                expirationYear: '20' + this.state.expiry.substring(3, 5),
                brand: this.state.issuer.toUpperCase(),
                cvv: this.state.cvc,
                holderName: this.state.name
            }

            let hashCount = localStorage.getItem('hashCount');

            // Caso seja null inicializa com 1
            if (hashCount === null) {
                localStorage.setItem('hashCount', '1');
                hashCount = '1';
            }

            generateCardHash(cardInfo);

            this.openModal();

            // Aguarda em loop a geração do hash
            while (localStorage.getItem('hashCount') == hashCount) {
                await this.sleep(1000);
            }

            this.verifyCardHash();
        }
        else {
            this.openModal();

            this.executeSiTefPayment();
        }
    };

    sleep = (ms : number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    verifyCardHash = async () => {
        this.gifLoading();

        let cardHash = localStorage.getItem('cardHash');

        let transactionDataPayGo = {
            'referenceId': this.ticket.strcodigo,
            'amount': (this.cobranca.douValorCobrado * 100).toString(),
            'description': 'Ticket Estacionamento - ' + this.ticket.strcodigo,
            'customer': {
                'name': this.state.name,
                'document': this.state.cpf
            },
            'payment': {
                "card": {
                    "type": 1,
                    "capture": false,
                    "installments": 1,
                    "interestType": 3,
                    "authenticate": 3,
                    "softDescriptor": "Pag. Estac. Ticket",
                    "cardInfo": {
                        "cardHash": cardHash
                    }
                }
            }
        };

        localStorage.setItem('transaction', JSON.stringify(transactionDataPayGo));

        let res: any;

        await TransactionServicePayGo.transaction(transactionDataPayGo).then(result => res = result).catch(err => {
            this.gifError();

            if (err.response.data == '[object Object]') {
                document.getElementById('errorMessage')!.innerHTML = 'Falha na transação, tente novamente'
            }

            return;
        });

        if (res != undefined) {
            document.getElementById('errorMessage')!.innerHTML = statusEnum[res.data.status];
        }
        else {
            return;
        }

        if (res.data.status == 5) {
            this.gifLoading();
            this.gifSuccess();

            await TicketService.postConfirmaPagamento().then(result => {
                localStorage.setItem('confirmaPagamento', JSON.stringify(result.config.data));
                localStorage.setItem('dataPagamento', moment().format('DD/MM/YYYY HH:mm:ss'));
                localStorage.setItem('respostaPagamento', JSON.stringify(result.data));
                setTimeout(() => { this.goToReceipt(); }, 1000);
            })
                .catch(err => {
                    this.gifError();
                    document.getElementById('errorMessage')!.innerHTML = err.response.data;

                    setTimeout(() => {
                        this.closeModal();
                    }, 2500);

                    return;
                });
        }
        else if ([4, 7, 9, 11, 12].includes(res.data.status)) {
            this.gifError();

            setTimeout(() => {
                this.closeModal();
            }, 2500);

            return;
        }
        else {
            // this.gifLoading();

            // setTimeout(() => {
            //     this.closeModal();
            // }, 2500);

            this.verifyCardHash();

            return;
        }
    }

    executeSiTefPayment = async () => {
        this.gifLoading();

        const issuer: string = this.state.issuer.toUpperCase();

        const autorizadora: autorizadorEnum = autorizadorEnum[issuer as keyof typeof autorizadorEnum];

        let transactionDataSiTef = {
            'installments': '1',
            'installment_type': '4',
            'authorizer_id': autorizadora,
            'amount': this.cobranca.douValorCobrado.toFixed(2).toString().replace('.', '')
        }

        localStorage.setItem('transaction', JSON.stringify(transactionDataSiTef));

        let res : any;

        const idEstacionamento = this.ticket.regestacionamento.idtblestacionamento.toString();

        await TransactionServiceSiTef.transaction(transactionDataSiTef, idEstacionamento).then(result => res = result).catch(err => {
            
            this.gifError();

            if (err.response.data == '[object Object]') {
                document.getElementById('errorMessage')!.innerHTML = 'Falha na transação, tente novamente'
            }
            else {
                document.getElementById('errorMessage')!.innerHTML = err.response.data;
            }

            setTimeout(() => {
                this.closeModal();
            }, 2500);

            return;
        });

        if (res != null && res.data != null && res.data.code == 0) {

            const paymentDataSiTef = {
                card: {
                    number: this.state.number.replace(/ /g, ''),
                    expiry_date: this.state.expiry.replace(/\D/g, ""),
                    security_code: this.state.cvc,
                    holder: this.state.name
                }
            };

            const key = 'ThWmZq4t7w!z$C&F)J@NcRfUjXn2r5u8';

            const encryptedCardData = this.encryptCardData(JSON.stringify(paymentDataSiTef), key);

            let resPayment: any;

            await PaymentServiceSiTef.payment(encryptedCardData, res.data.payment.nit, idEstacionamento)
            .then(result => {
                resPayment = result;
            })
            .catch(err => {
                console.error('Erro na chamada de PaymentServiceSiTef:', err.response);
                this.gifError();

                if (err.response) {
                    if (err.response.data === '[object Object]') {
                        document.getElementById('errorMessage')!.innerHTML = 'Falha na transação, tente novamente';
                    } 
                    else {
                        document.getElementById('errorMessage')!.innerHTML = err.response.data;
                    }
                }

                setTimeout(() => {
                this.closeModal();
                }, 2500);

                return;
            });

            if (resPayment && resPayment.data ) {
                if (resPayment.data.code == 0) {
                    this.gifSuccess();

                    await TicketService.postConfirmaPagamento().then(result => {
                        localStorage.setItem('confirmaPagamento', JSON.stringify(result.config.data));
                        localStorage.setItem('dataPagamento', moment().format('DD/MM/YYYY HH:mm:ss'));
                        localStorage.setItem('respostaPagamento', JSON.stringify(result.data));
                        setTimeout(() => { this.goToReceipt(); }, 1000);
                    })
                        .catch(err => {
                            this.gifError();
                            document.getElementById('errorMessage')!.innerHTML = err.response.data;
        
                            setTimeout(() => {
                                this.closeModal();
                            }, 2500);
        
                            return;
                        });
                }
                else {
                    this.gifError();
                    if (resPayment && resPayment.data){
                        document.getElementById('errorMessage')!.innerHTML = resPayment.data.message;
                    }
                    else {
                        document.getElementById('errorMessage')!.innerHTML = 'Falha ao confirmar pagamento. Contate o administrador!';
                    }

                    setTimeout(() => {
                        this.closeModal();
                    }, 2500);
        
                    return;
                }
            }
        }
        else {

            this.gifError();

            setTimeout(() => {
                this.closeModal();
            }, 2500);

            return;
        }
    }

    encryptCardData(input: string, key: string): string {
        // Converter a chave em uma representação adequada para o CryptoJS
        const keyBytes = CryptoJS.enc.Utf8.parse(key);
      
        // Realizar a criptografia AES em modo ECB
        const encrypted = CryptoJS.AES.encrypt(input, keyBytes, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
      
        // Converter o resultado para formato Base64
        const ciphertext = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      
        return ciphertext;
      }

    handleSwipe = (swipe: boolean, direction: boolean) => {
        this.setState({ swipe: !swipe });

        if (swipe) {
            if (direction) {
                document.documentElement.style.setProperty('--direction', '180deg');
            }
            else {
                document.documentElement.style.setProperty('--direction', '-180deg');
            }
            this.setState({
                focused: ''
            });
        }
        else if (!swipe) {
            if (direction) {
                document.documentElement.style.setProperty('--direction', '180deg');
            }
            else {
                document.documentElement.style.setProperty('--direction', '-180deg');
            }
            this.setState({
                focused: 'cvc'
            });
        }
    };

    goToLastPage = () => {
        window.history.go(-1);
    }

    goToReceipt = () => {
        window.location.href = '/Receipt';
    }

    goToTicket = () => {
        let idToken = localStorage.getItem('idToken');
        let idEstacionamento = localStorage.getItem('idEstacionamento');
        let codigoTicket = localStorage.getItem('codigoTicket');

        window.location.href = '/TK#' + idToken + '#' + idEstacionamento + '#' + codigoTicket;
    }

    openModal = () => this.setState({ isOpen: true });
    closeModal = () => this.setState({ isOpen: false });

    gifSuccess = () => this.setState({ gif: GifCerto });
    gifError = () => this.setState({ gif: GifErro });
    gifLoading = () => this.setState({ gif: GifCarregando });

    render() {

        const { name, number, expiry, cvc, focused, issuer, formData, swipe, gif } = this.state;

        const cobranca = JSON.parse(localStorage.getItem('cobranca')!) as ICobranca;

        var valor = 'R$ ' + cobranca.douValorCobrado.toFixed(2).toString().replace('.', ',');

        return (

            <>

                <Modal
                    aria-labelledby='modal-vcenter'
                    centered
                    show={this.state.isOpen}
                    onHide={this.closeModal}>
                    <ImageHeader src={gif} style={{ 'alignSelf': 'center' }} />
                    <Title style={{ 'textAlign': 'center' }} id='errorMessage'></Title>
                </Modal>

                <ReactTooltip place='right' id='cvvHint' type='light' effect='solid' globalEventOff='click'>
                    <span><ImageHeader src={DicaCVV} /></span>
                </ReactTooltip>

                <BackDiv className='mt-2'>
                    <BackButton onClick={this.goToLastPage} type='button' className='btn btn-icon-only'>
                        <span style={{ color: '#fff' }}><FontAwesomeIcon size='2x' icon={faChevronLeft as IconProp} /></span>
                    </BackButton>
                </BackDiv>

                <Container className='mt-2'>
                    <DivTextAlignCenter>
                        <ImageHeader src={Logo} />
                    </DivTextAlignCenter>

                    <hr />

                    <div>
                        <Swipeable
                            onSwipedRight={() => this.handleSwipe(swipe, true)}
                            onSwipedLeft={() => this.handleSwipe(swipe, false)}
                        >
                            <Card
                                number={number}
                                name={name}
                                expiry={expiry}
                                cvc={cvc}
                                focused={focused}
                                callback={this.handleCallback}
                                placeholders={{ name: 'NOME DO TITULAR' }}
                                locale={{ valid: 'VALIDADE' }}
                                acceptedCards={['visa', 'mastercard']}
                            />
                        </Swipeable>
                    </div>
                    <br />
                    <form ref={c => (this.form = c)} onSubmit={this.handleSubmit}>
                        <div className='form-group'>
                            <label>Número do cartão</label>
                            <input
                                type='tel'
                                id='number'
                                className='form-control'
                                pattern='[\d| ]{16,22}'
                                placeholder='Número do Cartão'
                                required
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                        <div className='form-group'>
                            <label>Nome impresso no cartão</label>
                            <input
                                type='text'
                                id='name'
                                className='form-control'
                                maxLength={45}
                                placeholder='Nome impresso no cartão'
                                required
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                        <div className='row'>
                            <div className='col-6'>
                                <label>Validade</label>
                                <input
                                    type='tel'
                                    id='expiry'
                                    className='form-control'
                                    pattern='\d\d/\d\d'
                                    placeholder='MM/AA'
                                    required
                                    onChange={this.handleInputChange}
                                    onFocus={this.handleInputFocus}
                                />
                            </div>
                            <div className='col-6'>
                                <label className='d-block'>CVV</label>
                                <input
                                    type='tel'
                                    id='cvc'
                                    className='form-control col-8 col-sm-9 d-inline-block'
                                    pattern='\d{3,4}'
                                    placeholder='CVV'
                                    required
                                    onChange={this.handleInputChange}
                                    onFocus={this.handleInputFocus}
                                />
                                <a data-tip data-for='cvvHint' data-event='mouseenter click' className='col-1 col-sm-3 d-inline-block'><FontAwesomeIcon style={{ fontSize: '1.5em' }} icon={faQuestionCircle as IconProp} /></a>
                            </div>
                        </div>

                        <div className='form-group mt-2'>
                            <label>CPF do titular</label>
                            <input
                                type='text'
                                id='cpf'
                                className='form-control'
                                placeholder='CPF do titular'
                                maxLength={45}
                                required
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>

                        <div className='form-group'>
                            <label>Valor a pagar</label>
                            <input
                                type='text'
                                id='total'
                                className='form-control'
                                maxLength={45}
                                readOnly
                                required
                                value={valor}
                                style={{ 'cursor': 'default', 'fontWeight': 'bold', 'textAlign': 'center', 'fontSize': '1.25em' }}
                            />
                        </div>

                        <input type='hidden' id='issuer' value={issuer} />

                        <br />

                        <div className='form-actions'>
                            <SubmitButton style={{ margin: '0 auto 0 auto' }}>PAGAR</SubmitButton>
                        </div>
                    </form>

                    <hr />

                    <DivTextAlignCenter>
                        <img src={PoweredBy} />
                    </DivTextAlignCenter>

                </Container>
            </>
        );
    }
}

export default PayCard;

